<template>
  <section class="section dashboard">

    <!-- selezione mesi -->
    <b-row class="mb-3 calendar-row">
      <b-col>
        <label>Periodo:</label>
        <vue-monthly-picker v-model="fromMonth" :monthLabels="monthLabels" dateFormat="MM/YYYY" /> -
        <vue-monthly-picker v-model="toMonth" :monthLabels="monthLabels" dateFormat="MM/YYYY" />
      </b-col>
    </b-row>

    <!-- mappa -->
    <gmap-map ref="map" :center="center" :zoom="6" gestureHandling="none"
      mapsApiKey="AIzaSyDXOnI0akFQqykkZZMrqC2R5JiSWBolzmU" class="mb-3 dashboard-multi-gmap">
      <gmap-marker :key="index" :ref="'marker' + m.id" v-for="(m, index) in sites" :position="m.position"
        @click="info(m)"></gmap-marker>
    </gmap-map>

    <!-- TEP -->
    <div class="dashboard-multi-tep" v-observe-visibility="(isVisible, entry) => visibilityChanged(
          isVisible, entry, 'tep')">
      <tep-stacked v-if="sites.length > 1 && visibility['tep']" ref="tep" :sites="sites" :monthFrom="monthFrom"
        :monthTo="monthTo" />
      <tep-mono-site v-if="sites.length === 1  && visibility['tep']" ref="tepMono" :site="sites[0]"
        :monthFrom="monthFrom" :monthTo="monthTo" />
    </div>


    <div class="dashboard-multi-slots" v-observe-visibility="(isVisible, entry) => visibilityChanged(
          isVisible, entry, 'slots')">
      <slots v-if="sites.length === 1 && visibility['slots']" :sites="sites" :monthFrom="monthFrom" :monthTo="monthTo">
      </slots>
    </div>

    <!-- IPG 
    <div class="dashboard-multi-ipg"
         v-observe-visibility="(isVisible, entry) => visibilityChanged(
          isVisible, entry, 'ipg')">
      <IPG
        v-if="visibility['ipg']"
        :monthFrom="monthFrom" :monthTo="monthTo" :sites="sites" />
    </div>

    <div class="dashboard-multi-charts"
         v-observe-visibility="(isVisible, entry) => visibilityChanged(
          isVisible, entry, 'charts')">
      <charts  v-if="visibility['charts']"
               :fromMonth="fromMonth" :toMonth="toMonth"  />
    </div>-->
  </section>
</template>

<script>

import Vue from "vue"
import TepStacked from "./Dashboard/TepStacked.vue"
import TepMonoSite from "./Dashboard/Tep/MonoSite"
import Slots from "./Dashboard/Slots/Slots"
import IPG from "./Dashboard/IPG/IPG.vue"
import Charts from "./Dashboard/Charts/Charts"
import VueMonthlyPicker from 'vue-monthly-picker'

/*
import * as GmapVue from "gmap-vue";
*/
import { version } from 'moment';
var moment = require('moment');

/*Vue.use(GmapVue.Autocomplete, {
  load: {
    key: "AIzaSyDo9j7zsgCGTmcRYITv-9Quczqp8bbBUh0"
  }
});*/

export default {
  name: 'DashboardMulti',
  components: {
    TepStacked, IPG, VueMonthlyPicker, TepMonoSite, Slots, Charts
  },

  data() {
    return {
      map: null,
      markers: [],
      mapReady: false,
      center: { lat: 45.508, lng: 9.587 },
      sites: [],
      fromMonth: moment().subtract(1, 'years'),
      toMonth: moment(),
      visibility: {},
    }
  },

  computed: {
    monthLabels() {
      return 'Gen_Feb_Mar_Apr_Mag_Giu_Lug_Ago_Set_Ott_Nov_Dic'.split('_')
    },
    monthFrom() {
      return this.fromMonth.format("YYYYMM")
    },
    monthTo() {
      return this.toMonth.format("YYYYMM")
    },
    terredavino() {
      return this.$store.state.user.username == 'terredavino-admin'
    },
  },

  watch: {
    sites(val) {
      this.panMap()
    }
  },

  created() {
    this.$store.dispatch('users/sites').then( data => {
      this.sites = data.map( s => {
        return {
            position: {
              lat: +s.latitude,
              lng: +s.longitude
            },
            id: s.id,
            guid: s.guid,
            name: s.name
          }
      })
    })
  },

  mounted() {
    this.$refs.map.$mapPromise.then( (map) => {
      this.mapReady = true
      map.setOptions({
        draggable: true,
        zoomControl: true,
        scrollwheel: false,
        disableDoubleClickZoom: false,
        styles: [
          {
              "featureType": "all",
              "elementType": "geometry.fill",
              "stylers": [
                  {
                      "weight": "2.00"
                  }
              ]
          },
          {
              "featureType": "all",
              "elementType": "geometry.stroke",
              "stylers": [
                  {
                      "color": "#9c9c9c"
                  }
              ]
          },
          {
              "featureType": "all",
              "elementType": "labels.text",
              "stylers": [
                  {
                      "visibility": "on"
                  }
              ]
          },
          {
              "featureType": "landscape",
              "elementType": "all",
              "stylers": [
                  {
                      "color": "#f2f2f2"
                  }
              ]
          },
          {
              "featureType": "landscape",
              "elementType": "geometry.fill",
              "stylers": [
                  {
                      "color": "#ffffff"
                  }
              ]
          },
          {
              "featureType": "landscape.man_made",
              "elementType": "geometry.fill",
              "stylers": [
                  {
                      "color": "#ffffff"
                  }
              ]
          },
          {
              "featureType": "poi",
              "elementType": "all",
              "stylers": [
                  {
                      "visibility": "off"
                  }
              ]
          },
          {
              "featureType": "road",
              "elementType": "all",
              "stylers": [
                  {
                      "saturation": -100
                  },
                  {
                      "lightness": 45
                  }
              ]
          },
          {
              "featureType": "road",
              "elementType": "geometry.fill",
              "stylers": [
                  {
                      "color": "#eeeeee"
                  }
              ]
          },
          {
              "featureType": "road",
              "elementType": "labels.text.fill",
              "stylers": [
                  {
                      "color": "#7b7b7b"
                  }
              ]
          },
          {
              "featureType": "road",
              "elementType": "labels.text.stroke",
              "stylers": [
                  {
                      "color": "#ffffff"
                  }
              ]
          },
          {
              "featureType": "road.highway",
              "elementType": "all",
              "stylers": [
                  {
                      "visibility": "simplified"
                  }
              ]
          },
          {
              "featureType": "road.arterial",
              "elementType": "labels.icon",
              "stylers": [
                  {
                      "visibility": "off"
                  }
              ]
          },
          {
              "featureType": "transit",
              "elementType": "all",
              "stylers": [
                  {
                      "visibility": "off"
                  }
              ]
          },
          {
              "featureType": "water",
              "elementType": "all",
              "stylers": [
                  {
                      "color": "#46bcec"
                  },
                  {
                      "visibility": "on"
                  }
              ]
          },
          {
              "featureType": "water",
              "elementType": "geometry.fill",
              "stylers": [
                  {
                      "color": "#c8d7d4"
                  }
              ]
          },
          {
              "featureType": "water",
              "elementType": "labels.text.fill",
              "stylers": [
                  {
                      "color": "#070707"
                  }
              ]
          },
          {
              "featureType": "water",
              "elementType": "labels.text.stroke",
              "stylers": [
                  {
                      "color": "#ffffff"
                  }
              ]
          }
        ]
      });
      this.panMap()
    })
  },

  methods: {
    visibilityChanged(isVisible, entry, key) {
      if (isVisible) {
        this.$set(this.visibility, key, isVisible);
      }
    },

    info(marker) {
      let params = {
        siteGuid: marker.guid,
        fromMonth: this.fromMonth.format('YYYYMM'),
        toMonth: this.toMonth.format('YYYYMM')
      }
      this.$store.dispatch("charts/summary", params).then( (data) => {

        var tpl = `<h4>${marker.name}</h4>`;

        var hasData = false
        for(let v in data) {
          hasData = true
          let vector = this.$store.state.vectors.list.find( (_) => { return _.code == v })
          data[v] = data[v].toFixed(0)
          tpl += `<p><strong>${vector.name}</strong>: ${data[v]} ${vector.mu}</p>`
        }

        if(! hasData) {
          tpl += "Nessun dato disponibile nel periodo selezionato"
        }

        let infowindow = new google.maps.InfoWindow({
          content: tpl
        });
        var m = this.$refs["marker" + marker.id][0].$markerObject
        infowindow.open(this.$refs.map, m);
      })
    },
    panMap() {
      if(this.mapReady) {
        if(this.sites.length > 1) {
          var bounds = new google.maps.LatLngBounds();
          this.sites.forEach(m => {
            bounds.extend(new google.maps.LatLng(m.position.lat, m.position.lng))
          })

          this.$refs.map.fitBounds(bounds)
        } else {
          if(this.sites.length > 1)
            this.$refs.map.panTo(new google.maps.LatLng(this.sites[0].position.lat, this.sites[0].position.lng))
        }
      }
    },
    refresh() {
      this.$refs.tep.setMonths([ this.selectedMonth ])
      this.$refs.tep.refresh()
      this.$store.commit('dashboardMonths', [ this.selectedMonth ])
    }
  },

  provide() {
    return {  }
  }
}
</script>
<style>
.vdpInnerWrap {
  min-width: 39em;
}
#map {
  width:100%;
  height: calc(100vh - 200px);
  min-height:300px
}
.dashboard
.vue-monthly-picker {
  display: inline-block;
  vertical-align: top;
}
.dashboard
.vue-monthly-picker .input  {
  border: 0;
  background: transparent;
  box-shadow: none;
  border-bottom: 1px dotted #999;
}
.calendar-row label {
  line-height: 34px;
}

.dashboard-multi-gmap {
  width:100%;
  height: calc(100vh - 200px);
  min-height: 400px
}

.dashboard-multi-tep {
  min-height: 400px;
}
</style>




// WEBPACK FOOTER //
// src/components/DashboardMulti.vue